import { Atendimentos } from "app/types/cliente/DadosAtendimento";
import { FiltrosAtendimento } from "app/types/cliente/FiltrosAtendimento";
import { Vendedor } from "app/types/Vendedor";
import { PagedMessageResponse } from "../types/PagedMessageResponse";
import { BaseApi } from "./BaseApi";

export class AtendimentoClienteApi extends BaseApi {
  
  async Pesquisar(): Promise<DadosAtendimento> {
    return (
      await this.api.get(`/AtendimentoCliente/Pesquisar`)
    ).data;
  }

  async DefinirLeitura(codigoAtendimento: number, lido: boolean): Promise<any> { // 444842
      await this.api.post(`/AtendimentoCliente/DefinirLeitura`, {
        codigoAtendimento: codigoAtendimento,
        lido: lido
      })
  }

  async Listar(filtros: FiltrosAtendimento): Promise<PagedMessageResponse<Atendimentos>> {
    return (
      await this.api.post(`/AtendimentoCliente/Listar`, {
        filtros
      })
    ).data;
  }

  async ListarAtividadesPorDescricao(descricao: string): Promise<any> {
    return (
      await this.api.post(`/AtendimentoCliente/ListarAtividadesPorDescricao`, {
        descricao
      })
    ).data;
  }
  async ListarMotivosPorNome(nome: string): Promise<any> {
    return (
      await this.api.post(`/AtendimentoCliente/ListarMotivosPorNome`, {
        nome
      })
    ).data;
  }

  async DadosCadastro(): Promise<string> {
    return (
      await this.api.post(`/AtendimentoCliente/DadosCadastro`, {

      })
    ).data;
  }
}


export type DadosAtendimento = {
  vendedor: Vendedor
  ordenacao: Ordenacao[]
}

export type Ordenacao = {
  Description: string
  Value: string
}


